import {sendHelpClickLog} from '@/utils/help/log';
import globalDomains from '@/utils/global-domains';
import {HELP_LOG} from '@/constants/help';
import styles from './InfoBanner.module.scss';

const InfoBanner = () => {
  const sendClickLog = (
    actionType:
      | typeof HELP_LOG.ACTION_TYPE.TO_BROAD
      | typeof HELP_LOG.ACTION_TYPE.TO_STREAMER,
  ) => {
    sendHelpClickLog(HELP_LOG.CODE_TYPE.MAIN_BANNER, {
      buttonType: HELP_LOG.BUTTON_TYPE.CS_GUIDE,
      actionType,
    });
  };

  const bannerList = [
    {
      title: 'SOOP 스트리머 가이드',
      style: styles.GuideBanner,
      link: globalDomains.BJGUIDE_AFREECATV,
      actionType: HELP_LOG.ACTION_TYPE.TO_STREAMER,
      description: 'SOOP에서는 스트리머를 적극 지원하고 있습니다.',
    },
    {
      title: 'SOOP에서 방송하기',
      style: styles.TechBanner,
      link: `${globalDomains.BJGUIDE_AFREECATV}/tech.php`,
      actionType: HELP_LOG.ACTION_TYPE.TO_BROAD,
      description: '방송하기 관련하여 안내드립니다.',
    },
  ];

  return (
    <div className={styles.InfoBannerWrapper}>
      {bannerList.map(({title, style, link, actionType, description}) => (
        <a
          key={title}
          className={style}
          href={link}
          target='_blank'
          onClick={() => sendClickLog(actionType)}>
          <div>
            <strong>{title}</strong>
            <p>{description}</p>
          </div>
        </a>
      ))}
    </div>
  );
};

export default InfoBanner;
